export default "__VITE_ASSET__BBirSteq__"